"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Message = exports.MessageType = void 0;
var MessageType;
(function (MessageType) {
    MessageType[MessageType["CREATE_NODE"] = 0] = "CREATE_NODE";
    MessageType[MessageType["DESTROY_NODE"] = 1] = "DESTROY_NODE";
    MessageType[MessageType["CREATE_PUBLISHER"] = 2] = "CREATE_PUBLISHER";
    MessageType[MessageType["DESTROY_PUBLISHER"] = 3] = "DESTROY_PUBLISHER";
    MessageType[MessageType["PUBLISHER_MESSAGE"] = 4] = "PUBLISHER_MESSAGE";
    MessageType[MessageType["CREATE_SUBSCRIPTION"] = 5] = "CREATE_SUBSCRIPTION";
    MessageType[MessageType["DESTROY_SUBSCRIPTION"] = 6] = "DESTROY_SUBSCRIPTION";
    MessageType[MessageType["SUBSCRIPTION_MESSAGE"] = 7] = "SUBSCRIPTION_MESSAGE";
    MessageType[MessageType["CREATE_CLIENT"] = 8] = "CREATE_CLIENT";
    MessageType[MessageType["DESTROY_CLIENT"] = 9] = "DESTROY_CLIENT";
    MessageType[MessageType["CLIENT_REQUEST"] = 10] = "CLIENT_REQUEST";
    MessageType[MessageType["CREATE_SERVICE"] = 11] = "CREATE_SERVICE";
    MessageType[MessageType["DESTROY_SERVICE"] = 12] = "DESTROY_SERVICE";
    MessageType[MessageType["SERVICE_RESPONSE"] = 13] = "SERVICE_RESPONSE";
})(MessageType = exports.MessageType || (exports.MessageType = {}));
class Message {
    constructor(type, content, id) {
        this.type = type;
        this.content = content;
        this.id = id ? id : String(Message.idCounter++);
    }
    static parseMessage(message) {
        const jsonMessage = JSON.parse(message);
        const typeKey = jsonMessage["type"];
        const type = MessageType[typeKey];
        const content = jsonMessage["content"];
        const id = String(jsonMessage["id"]);
        return new Message(type, content, id);
    }
    toString() {
        return JSON.stringify({
            type: MessageType[this.type],
            id: this.id,
            content: this.content,
        });
    }
}
exports.Message = Message;
Message.idCounter = 0;
